<template>
  <div class="content album-detail-page album-studio">
    <el-form
        :model="updateAlbumRequest"
        :rules="rules"
        ref="updateAlbumRequest"
        label-width="120px"
        class="demo-ruleForm album-form"
    >
      <!-- Header card -->
      <div class="page-header-card">
        <div class="album-heading">
        <div class="album-heading__icon"><i class="el-icon-picture-outline" aria-hidden="true" /></div>
        <div>
          <span class="album-heading__eyebrow">THƯ VIỆN ẢNH</span>
          <h2 class="page-title">Chi tiết album</h2>
          <p class="page-description">
            Chỉnh sửa thông tin album, thêm ảnh mới hoặc duyệt ảnh đã tải lên.
          </p>
        </div>
      </div>
        <div class="header-badges">
          <div class="summary-badge">
            <span class="summary-badge__label">Đối tượng</span>
            <strong class="summary-badge__value">
              {{ updateAlbumRequest.selectObject === 'student' ? 'Lớp' : 'Trường' }}
            </strong>
          </div>
          <div class="summary-badge summary-badge--highlight">
            <span class="summary-badge__label">Ảnh đã duyệt</span>
            <strong class="summary-badge__value">
              {{ updateAlbumRequest.pictureApprovedNumber || 0 }}/{{ updateAlbumRequest.pictureNumber || 0 }}
            </strong>
          </div>
          <div class="summary-badge">
            <span class="summary-badge__label">Trạng thái album</span>
            <strong class="summary-badge__value">
              {{ updateAlbumRequest.albumApproved ? 'Đang hiện' : 'Đã ẩn' }}
            </strong>
          </div>
        </div>
      </div>

      <div class="form-shell">
        <div class="album-form-main">
          <!-- Thông tin album -->
          <section class="section-card album-info-section">
            <div class="section-heading">
              <h3 class="section-title"><i class="el-icon-document" aria-hidden="true" />Thông tin album</h3>
              <p class="section-description">Chỉnh sửa tên, đối tượng và mô tả album.</p>
            </div>

            <el-row :gutter="20">
              <el-col :xs="24" :md="12">
                <el-form-item class="field-item" label="Tên album" prop="albumName">
                  <el-input
                      v-model="updateAlbumRequest.albumName"
                      placeholder="Nhập tiêu đề..."
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :md="12">
                <el-form-item class="field-item" label="Đối tượng">
                  <el-select
                      popper-class="album-studio-popper"
                      @change="handleChangeObject"
                      v-model="updateAlbumRequest.selectObject"
                      placeholder="Chọn đối tượng"
                      class="full-width"
                  >
                    <el-option
                        v-for="item in listSelectObject"
                        :key="item.id"
                        :label="item.label"
                        :value="item.value"
                    >
                      <span>{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="description-item" label="Mô tả album" prop="desc">
              <el-input
                  v-model="updateAlbumRequest.albumDescription"
                  placeholder="Nhập nội dung..."
                  :rows="3"
                  type="textarea"
              ></el-input>
            </el-form-item>
          </section>

          <!-- Phạm vi học sinh -->
          <section v-if="updateAlbumRequest.selectObject === 'student'" class="section-card album-audience-section">
            <div class="section-heading section-heading--space-between">
              <div>
                <h3 class="section-title"><i class="el-icon-user" aria-hidden="true" />Phạm vi học sinh</h3>
                <p class="section-description">Chọn học sinh áp dụng cho album theo từng lớp.</p>
              </div>
              <Phase2ActionButton
                  @click="clickSelectStudent"
                  type="primary"
                  icon="el-icon-user"
                  class="student-select-button"
              >
                Chọn học sinh trong lớp
              </Phase2ActionButton>
            </div>

            <div class="student-list-panel">
              <div class="student-list-panel__header">
                <div>
                  <h4 class="student-list-title">Danh sách học sinh</h4>
                  <span class="student-list-subtitle">
                    Đã chọn {{ updateAlbumRequest.kids ? updateAlbumRequest.kids.length : 0 }} học sinh
                  </span>
                </div>
                <el-input
                    v-if="updateAlbumRequest.kids && updateAlbumRequest.kids.length"
                    v-model="selectedStudentSearch"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Tìm theo tên hoặc lớp"
                    label="Tìm học sinh đã chọn"
                    class="student-list-search"
                />
                <span v-if="selectedStudentSearch.trim()" class="student-search-count" role="status">
                  Tìm thấy {{ filteredSelectedKids.length }} học sinh
                </span>
              </div>

              <div v-if="!updateAlbumRequest.kids || updateAlbumRequest.kids.length === 0" class="student-empty-state">
                <i class="el-icon-user-solid student-empty-state__icon"></i>
                <div class="student-empty-state__title">Chưa có học sinh nào được chọn</div>
                <div class="student-empty-state__desc">
                  Nhấn <strong>Chọn học sinh trong lớp</strong> để thêm học sinh vào album này.
                </div>
              </div>

              <div v-else-if="filteredSelectedKids.length === 0" class="student-search-empty" role="status">
                Không tìm thấy học sinh phù hợp.
              </div>

              <div v-else class="answer_apply">
                <div v-for="(kid, index) in filteredSelectedKids" :key="index" class="kid-row">
                  <div class="kid-row__icon-wrap">
                    <i class="el-icon-circle-check kid-row__icon"/>
                  </div>
                  <div class="kid-row__content">
                    <div class="kid-row__name">{{ kid.kidsName }}</div>
                    <div class="kid-row__meta">
                      {{ parseKidStatusVietnamese(kid.statusKids) }} • {{ kid.className }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- Thêm ảnh mới -->
        <section class="section-card album-upload-section">
          <div class="section-heading">
            <h3 class="section-title"><i class="el-icon-upload" aria-hidden="true" />Thêm ảnh mới</h3>
            <p class="section-description">Kéo thả hoặc chọn thêm ảnh, kiểm tra trước khi lưu vào album.</p>
          </div>

          <div class="upload-toolbar">
            <div class="upload-left">
              <div class="upload-note-card">
                <span class="upload-note-card__label">Đang chờ tải lên</span>
                <strong class="upload-note-card__value">{{ fileList.length }} ảnh</strong>
              </div>

              <div class="selected-summary" v-if="fileList && fileList.length > 0">
                <img :src="fileList[0].url" class="selected-summary__thumb" alt="ảnh"/>
                <div class="selected-summary__text">{{ fileList.length }} ảnh đã chọn</div>
              </div>
              <div class="selected-summary" v-else>
                <div class="selected-summary__empty">Chưa có ảnh mới</div>
              </div>
            </div>

            <div class="upload-right">
              <div class="progress-wrap" v-if="showProgress">
                <el-progress
                    class="upload-progress"
                    :percentage="percentage"
                    :color="colors"
                ></el-progress>
                <div class="progress-label">{{ percentage }}%</div>
              </div>
            </div>
          </div>

          <el-upload
              action="#"
              drag
              list-type="picture-card"
              :auto-upload="false"
              ref="upload"
              :file-list="fileList"
              :on-change="handleChangePicture"
              :on-remove="handleRemove"
              multiple
              class="upload-area"
          >
            <template #default>
              <div class="upload-trigger">
                <i class="el-icon-upload upload-trigger__icon" aria-hidden="true"></i>
                <strong class="upload-trigger__text">Kéo thả ảnh vào đây</strong>
                <span class="upload-trigger__description">Chọn nhiều ảnh cùng lúc hoặc bấm để chọn từ máy</span>
                <span class="upload-trigger__button"><i class="el-icon-plus" aria-hidden="true" /> Chọn ảnh từ máy</span>
              </div>
            </template>
            <template #file="{ file }">
              <div class="container_image_upload">
                <TagFlag title="Mới"/>
                <img class="el-upload-list__item-thumbnail" :src="getPreview(file)" alt="Ảnh mới"/>
                <div class="upload-thumbnail-actions">
                  <button type="button" class="upload-thumbnail-action" :aria-label="'Xem ảnh ' + file.name" title="Xem ảnh" @click.stop="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in" aria-hidden="true"></i>
                  </button>
                  <button v-if="!disabled" type="button" class="upload-thumbnail-action upload-thumbnail-action--delete" :aria-label="'Bỏ ảnh ' + file.name" title="Bỏ ảnh" @click.stop="handleRemove(file)">
                    <i class="el-icon-delete" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </template>
          </el-upload>

          <div class="upload-help-text">JPG/PNG, tối đa 5MB/ảnh · Ảnh mới sẽ được bổ sung khi lưu</div>

          <el-dialog class="album-studio-upload-preview" title="Xem ảnh mới" width="70%" :visible.sync="dialogVisible" top="32px">
            <img width="100%" :src="dialogImageUrl" alt/>
          </el-dialog>
        </section>

        <!-- Danh sách ảnh album -->
        <section class="section-card album-gallery-section">
          <div class="section-heading section-heading--space-between">
            <div>
              <h3 class="section-title">
                <i class="el-icon-picture-outline" aria-hidden="true" />Danh sách ảnh album
                <span class="album-name-inline" v-if="updateAlbumRequest.albumName">
                  — {{ updateAlbumRequest.albumName }}
                </span>
              </h3>
                <p class="section-description">Xem, duyệt hoặc xóa ảnh đã có trong album.</p>
            </div>
            <div class="picture-section-actions">
              <div class="picture-count-badge" v-if="Array.isArray(updateAlbumRequest.alistPictureList)">
                <i class="el-icon-picture"/> {{ updateAlbumRequest.alistPictureList.length }} ảnh
              </div>

            </div>
          </div>

          <div class="album-load-state" v-if="detailLoading" role="status" aria-live="polite">
            <i class="el-icon-loading" /> Đang tải ảnh album…
          </div>
          <div class="album-load-state album-load-state--error" v-else-if="detailError" role="alert">
            <i class="el-icon-warning-outline" /> Không tải được chi tiết album.
            <el-button size="small" icon="el-icon-refresh" @click="getAlumDetail">Thử lại</el-button>
          </div>
          <div class="album-picture-filters" role="group" aria-label="Lọc trạng thái ảnh" v-if="!detailLoading && !detailError && alistPictureList.length">
            <button v-for="filter in pictureFilters" :key="filter.value" type="button"
                :class="{ 'is-active': pictureFilter === filter.value }" :aria-pressed="pictureFilter === filter.value"
                @click="pictureFilter = filter.value">
              {{ filter.label }} <span>{{ filter.count }}</span>
            </button>
          </div>
          <div
              v-if="!detailLoading && !detailError && alistPictureList.length"
              class="picture-selection-bar"
          >
            <el-checkbox
                v-model="checkAllPictures"
                :indeterminate="pictureSelectionIndeterminate"
                :disabled="deletePictureLoading || pictureApprovalLoading || !visiblePictures.length"
                @change="handleCheckAllPictures"
            >Chọn ảnh đang hiển thị</el-checkbox>
            <span v-if="selectedPictureIdxs.length > 0" class="picture-selection-bar__count">
              Đã chọn {{ selectedPictureIdxs.length }} ảnh
              <small v-if="hiddenSelectedPictureCount">({{ hiddenSelectedPictureCount }} ảnh ngoài bộ lọc)</small>
            </span>
            <template v-if="selectedPictureIdxs.length">
              <div class="picture-selection-bar__actions" v-if="checkPermission(['studentQuality_ablum_update'])">
                <el-button size="small" type="primary" icon="el-icon-check"
                    :loading="pictureApprovalLoading && pictureApprovalTarget" :disabled="pictureApprovalLoading || deletePictureLoading"
                    @click="updateAllPictureApproval(true)">Duyệt {{ selectedPictureIdxs.length }} ảnh</el-button>
                <el-button size="small" icon="el-icon-close"
                    :loading="pictureApprovalLoading && !pictureApprovalTarget" :disabled="pictureApprovalLoading || deletePictureLoading"
                    @click="updateAllPictureApproval(false)">Hủy duyệt {{ selectedPictureIdxs.length }} ảnh</el-button>
                <el-button size="small" type="danger" plain icon="el-icon-delete"
                    :loading="deletePictureLoading" :disabled="pictureApprovalLoading || deletePictureLoading"
                    @click="deleteSelectedPictures">Xóa {{ selectedPictureIdxs.length }} ảnh</el-button>
              </div>
              <el-button type="text" :disabled="pictureApprovalLoading || deletePictureLoading" @click="resetPictureSelection">Bỏ chọn</el-button>
            </template>
          </div>

          <div
              v-if="!detailLoading && !detailError && visiblePictures.length"
              class="picture-grid"
              role="region"
              aria-label="Danh sách ảnh album"
              tabindex="0"
          >
            <div
                v-for="listPicture in visiblePictures"
                :key="getPictureIdx(listPicture)"
                class="picture-card"
                :class="{ 'picture-card--selected': listPicture.checkDelete }"
            >
                <div class="picture-card__img-wrap">
                  <button type="button" class="album-picture-open" :aria-label="'Xem ảnh ' + (alistPictureList.indexOf(listPicture) + 1)"
                      @click="handleShowDetailPicture(alistPictureList.indexOf(listPicture), listPicture, $event)">
                  <el-tooltip content="Xem ảnh" placement="top">
                    <el-image
                        v-if="listPicture.urlPictureShow && !listPicture.imageError"
                        :src="listPicture.urlPictureShow"
                        class="picture-card__img el-image-opacity"
                        fit="cover"
                        @error="handleAlbumImageError(listPicture)"
                    >
                      <div slot="placeholder" class="picture-card__image-loading">
                        <i class="el-icon-loading" />
                        <span>Đang tải ảnh</span>
                      </div>
                    </el-image>
                    <div v-else class="picture-card__image-fallback">
                      <i :class="listPicture.imageLoading ? 'el-icon-loading' : 'el-icon-picture-outline'" />
                      <span>{{ listPicture.imageLoading ? 'Đang tải ảnh' : 'Không tải được ảnh' }}</span>
                    </div>
                  </el-tooltip>
                  </button>
                  <el-button v-if="listPicture.imageError && !listPicture.imageLoading" class="album-image-retry"
                      size="mini" icon="el-icon-refresh" @click="retryAlbumImage(listPicture)">Thử lại</el-button>
                  <div
                      v-if="listPicture.representative || listPicture.isRepresentative || listPicture.isAvatar"
                      class="picture-card__representative-badge"
                      title="Ảnh đại diện album"
                      aria-label="Ảnh đại diện album"
                  >
                    <i class="el-icon-star-on" aria-hidden="true" />
                  </div>
                  <div class="picture-card__badge" :class="listPicture.isApproved ? 'badge--approved' : 'badge--pending'">
                    {{ listPicture.isApproved ? 'Đã duyệt' : 'Chờ duyệt' }}
                  </div>
                </div>

                <div class="picture-card__selection">
                  <el-checkbox
                      v-model="listPicture.checkDelete"
                      class="picture-card__select"
                      :disabled="deletePictureLoading || pictureApprovalLoading"
                      @change="handlePictureSelectionChange(listPicture)"
                  >Chọn ảnh</el-checkbox>
                </div>

                <div class="picture-card__actions" v-if="checkPermission(['studentQuality_ablum_update'])">
                  <el-tooltip v-if="!listPicture.isApproved" content="Duyệt ảnh" placement="top">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-check"
                        aria-label="Duyệt ảnh"
                        :disabled="pictureApprovalLoading"
                        class="picture-card__btn picture-card__btn--approve"
                        @click="updateApprovePicture(listPicture.pictureIdx, true)"
                    />
                  </el-tooltip>
                  <el-tooltip v-else content="Hủy duyệt ảnh" placement="top">
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-close"
                        aria-label="Hủy duyệt ảnh"
                        :disabled="pictureApprovalLoading"
                        class="picture-card__btn picture-card__btn--approved"
                        @click="updateApprovePicture(listPicture.pictureIdx, false)"
                    />
                  </el-tooltip>
                  <el-tooltip content="Xóa ảnh" placement="top">
                    <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        aria-label="Xóa ảnh"
                        class="picture-card__btn picture-card__btn--delete"
                        :loading="deletePictureLoading && deletingPictureIdxs.includes(String(listPicture.pictureIdx))"
                        :disabled="deletePictureLoading || pictureApprovalLoading"
                        @click="deleteSinglePicture(listPicture)"
                    />
                  </el-tooltip>
                </div>
            </div>
          </div>

          <div v-else-if="!detailLoading && !detailError" class="pictures-empty-state">
            <i class="el-icon-picture-outline pictures-empty-state__icon"></i>
            <div class="pictures-empty-state__title">{{ alistPictureList.length ? 'Không có ảnh trong trạng thái này' : 'Album chưa có ảnh nào' }}</div>
            <div class="pictures-empty-state__desc">{{ alistPictureList.length ? 'Chọn trạng thái khác để tiếp tục xem ảnh.' : 'Hãy tải ảnh lên ở phần Thêm ảnh mới phía trên.' }}</div>
          </div>
        </section>
      </div>

      <!-- Footer actions -->
      <div class="actions-footer">
        <div class="actions-footer__left">
          <span class="meta-author"><strong>Người đăng:</strong> {{ updateAlbumRequest.createdBy }}</span>
          <span class="meta-divider">|</span>
          <span class="meta-info">{{ updateAlbumRequest.pictureApprovedNumber }}/{{ updateAlbumRequest.pictureNumber }} ảnh</span>
          <span class="meta-divider">|</span>
          <span class="meta-info">{{ updateAlbumRequest.createdDate | formatDate }}</span>
        </div>
        <div class="actions-footer__right">
          <Phase2ActionButton
              v-if="checkPermission(['studentQuality_ablum_update'])"
              type="primary"
              size="small"
              @click="submitUpload('updateAlbumRequest')"
              icon="el-icon-circle-check"
              :loading="loadingButton"
              :disabled="loadingButton || compressingCount > 0 || detailLoading || detailError"
          >
            Lưu thay đổi
          </Phase2ActionButton>
          <router-link to="/album-v2" class="cancel-link">
            <Phase2ActionButton type="default" size="small" icon="el-icon-back">
              Quay lại
            </Phase2ActionButton>
          </router-link>
        </div>
      </div>
    </el-form>

    <div
        v-if="showUpdateProgress"
        class="album-update-progress-overlay album-studio-progress"
        role="status"
        aria-live="polite"
    >
      <div class="album-update-progress-card">
        <i class="el-icon-loading album-update-progress-card__icon"></i>
        <h3 class="album-update-progress-card__title">{{ updateProgressTitle }}</h3>
        <p class="album-update-progress-card__message">{{ updateProgressMessage }}</p>
        <el-progress
            :percentage="percentage"
            :color="colors"
            :show-text="false"
            class="album-update-progress-card__bar"
        ></el-progress>
        <div class="album-update-progress-card__percent">{{ percentage }}%</div>
        <p class="album-update-progress-card__note">Vui lòng không đóng trang trong quá trình xử lý.</p>
      </div>
    </div>

    <AlbumDownloadProgressDialog
        :visible="showDownloadProgress"
        indeterminate
        :percentage="downloadProgress"
        :title="downloadProgressTitle"
        :message="downloadProgressMessage"
    />

    <!-- Dialog xem ảnh chi tiết -->
    <el-dialog ref="pictureViewer" :fullscreen="viewerFullscreen" @opened="onViewerOpened" @closed="onViewerClosed" @keydown.native="handleViewerKeydown" class="album-preview-dialog album-studio-viewer" :title="'Ảnh ' + (indexSrc + 1) + ' / ' + alistPictureList.length" width="82%" :visible.sync="dialogVisiblePic" top="32px">
      <template #title>
        <div class="album-viewer-heading">
          <span>{{ updateAlbumRequest.albumName }}</span>
          <small>Ảnh {{ indexSrc + 1 }} / {{ alistPictureList.length }}</small>
        </div>
      </template>
      <div class="album-viewer-tools" role="group" aria-label="Điều khiển ảnh">
        <el-button size="mini" icon="el-icon-zoom-out" :disabled="viewerZoom <= 1" @click="changeViewerZoom(-0.25)" aria-label="Thu nhỏ" />
        <span aria-live="polite">{{ Math.round(viewerZoom * 100) }}%</span>
        <el-button size="mini" icon="el-icon-zoom-in" :disabled="viewerZoom >= 3" @click="changeViewerZoom(0.25)" aria-label="Phóng to" />
        <el-button size="mini" @click="viewerZoom = 1">Vừa khung</el-button>
        <el-button size="mini" icon="el-icon-full-screen" :aria-pressed="viewerFullscreen" @click="viewerFullscreen = !viewerFullscreen">{{ viewerFullscreen ? 'Thu gọn' : 'Toàn màn hình' }}</el-button>
      </div>
      <div class="image-container" :class="{ 'is-zoomed': viewerZoom > 1 }">
        <div class="album-viewer-image-stage" :style="{ width: (viewerZoom * 100) + '%', height: (viewerZoom * 100) + '%' }">
        <img v-if="selectedImg" class="centered-image" :src="selectedImg" @error="handlePreviewImageError" alt="Ảnh album"/>
        <div v-else class="picture-card__image-fallback">
          <i :class="selectedPictureLoading ? 'el-icon-loading' : 'el-icon-picture-outline'" />
          <span>{{ selectedPictureLoading ? 'Đang tải ảnh' : 'Không tải được ảnh' }}</span>
          <el-button v-if="!selectedPictureLoading && alistPictureList[indexSrc]" size="small" icon="el-icon-refresh" @click="retryAlbumImage(alistPictureList[indexSrc])">Thử lại</el-button>
        </div>
        </div>
      </div>
      <div class="album-viewer-thumbnails" role="group" aria-label="Chuyển ảnh trong album">
        <button v-for="(picture, index) in alistPictureList" :key="getPictureIdx(picture)" type="button"
            :class="{ 'is-active': index === indexSrc }" :aria-label="'Xem ảnh ' + (index + 1)" :aria-pressed="index === indexSrc"
            @click="showViewerPicture(index)">
          <img v-if="picture.urlPictureShow && !picture.imageError" :src="picture.urlPictureShow" alt="" />
          <i v-else :class="picture.imageLoading ? 'el-icon-loading' : 'el-icon-picture-outline'" />
          <span>{{ index + 1 }}</span>
        </button>
      </div>
      <template #footer>
        <div class="button-container">
          <Phase2ActionButton
              @click="backPage"
              type="default"
              size="small"
              icon="el-icon-d-arrow-left"
              :disabled="indexSrc <= 0"
          >Trước</Phase2ActionButton>
          <Phase2ActionButton
              type="default"
              size="small"
              icon="el-icon-download"
              @click="downloadCurrentPicture"
              :loading="downloadingPicture"
              :disabled="downloadingPicture"
          >Tải ảnh</Phase2ActionButton>
          <Phase2ActionButton
              type="primary"
              size="small"
              icon="el-icon-picture"
              @click="setUpAvatarAlbum"
              :loading="settingAvatar"
              :disabled="settingAvatar"
          >
            Đặt làm ảnh đại diện
          </Phase2ActionButton>
          <Phase2ActionButton
              @click="nextPage"
              type="default"
              size="small"
              :disabled="indexSrc >= alistPictureList.length - 1"
          >
            <span>Sau</span>
            <i class="el-icon-d-arrow-right"></i>
          </Phase2ActionButton>
        </div>
      </template>
    </el-dialog>

    <AddStudentUpdateAlbumDialog
        :kidsInSchool="kidsInSchool"
        :getAppTypeUserLogin="getAppTypeUserLogin"
        :initialClasses="updateAlbumRequest.classIds || updateAlbumRequest.classes || []"
        :initialKidIds="updateAlbumRequest.listIdKidApply || []"
        :isAddStudentUpdateAlbumDialog="isAddStudentUpdateAlbumDialog"
        @closeDialog="closeAddStudentUpdateAlbumDialog"
        @confirmData="handleConfirmKidsApply"
    />
  </div>
</template>

<script>
import "./styles/album-studio.scss";
import checkPermission from "@/utils/permission.js";
import AlbumService from "./services/AlbumService";
import AlbumImageUrlService from "./services/AlbumImageUrlService";
import {mapState} from "vuex";
import TagFlag from "@/views/tag/TagFlag.vue";
import AddStudentUpdateAlbumDialog from "./AddStudentUpdateAlbumDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import SurveyForm from "@/services/SurveyForm";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";
import pica from "pica";
import Phase2ActionButton from "@/components/common/phase2/Phase2ActionButton.vue";
import AlbumDownloadProgressDialog from "./components/AlbumDownloadProgressDialog.vue";

export default {
  components: {
    TagFlag,
    AddStudentUpdateAlbumDialog,
    Phase2ActionButton,
    AlbumDownloadProgressDialog,
  },
  beforeCreate() {
    this._albumImageLoader = {
      queue: [],
      running: false,
      searchId: 0,
      destroyed: false,
    };
  },
  data() {
    return {
      selectedStudentSearch: "",
      indexSrc: 0,
      pictureFilter: "all",
      viewerZoom: 1,
      viewerFullscreen: false,
      detailLoading: true,
      detailError: false,
      colors: [
        {color: "#9bd4dc", percentage: 20},
        {color: "#65b6b5", percentage: 40},
        {color: "#4b91c5", percentage: 60},
        {color: "#477ab8", percentage: 80},
        {color: "#6f79bd", percentage: 100},
      ],
      percentage: 0,
      showProgress: false,
      showUpdateProgress: false,
      updateProgressTitle: "Đang cập nhật album",
      updateProgressMessage: "Đang chuẩn bị dữ liệu cập nhật...",
      value: "",
      updateAlbumRequest: {
        id: "",
        albumName: "",
        albumDescription: "",
        albumType: "",
        albumApprovalDefault: "",
        idSchoolApproval: "",
        schoolApprovalDate: "",
        urlPictureFirst: "",
        pictureNumber: "",
        pictureApprovedNumber: "",
        idClass: "",
        idSchool: "",
        createdDate: "",
        createdBy: "",
        fileList: [],
        alistPictureList: [],
        classes: [],
        classIds: [],
        kids: [],
        listIdKidApply: [],
        selectObject: "school"
      },
      rules: {
        albumName: [
          {
            required: true,
            message: "Tên album không được để trống",
            trigger: "blur",
          },
        ],
      },
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisiblePic: false,
      disabled: false,
      showCreateDialog: false,
      showUpdateDialog: false,
      idList: [],
      srcs: [
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%203.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2014.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
      ],
      alistPictureList: [],
      selectedImg: "",
      currentPage: "",
      totalPages: "",
      qualityPicture: "",
      widthPicture: "",
      listUpdate: [],
      selectedPictureIdx: "",
      settingAvatar: false,
      downloadingPicture: false,
      deletePictureLoading: false,
      pictureApprovalLoading: false,
      pictureApprovalTarget: true,
      deletingPictureIdxs: [],
      selectedPictureIdxs: [],
      checkAllPictures: false,
      pictureSelectionIndeterminate: false,
      showDownloadProgress: false,
      downloadProgress: 0,
      downloadProgressTitle: "Đang chuẩn bị tải ảnh",
      downloadProgressMessage: "Đang tạo liên kết tải xuống...",
      loadingButton: false,
      isAddStudentUpdateAlbumDialog: false,
      kidsInSchool: [],
      classesApply: [],
      kidsDataFilter: [],
      compressingCount: 0,
      compressPromises: [],
      picaResizer: null,
    };
  },
  created() {
    this.picaResizer = pica({
      features: ["js", "wasm", "ww"],
    });
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.runSequentially();
    this.handleChangeObject();
  },
  mixins: [
    parseInfoKidVietnameseMixin,
  ],
  watch: {
    pictureFilter() { this.syncPictureSelectionState(); },
  },
  computed: {
    visiblePictures() {
      return (this.alistPictureList || []).filter(picture => this.pictureFilter === "all"
          || (this.pictureFilter === "approved" ? picture.isApproved : !picture.isApproved));
    },
    hiddenSelectedPictureCount() {
      return this.selectedPictureIdxs.length - this.visiblePictures.filter(picture => picture.checkDelete).length;
    },
    pictureFilters() {
      const pictures = this.alistPictureList || [];
      const approved = pictures.filter(picture => picture.isApproved).length;
      return [
        {value: "all", label: "Tất cả", count: pictures.length},
        {value: "pending", label: "Chờ duyệt", count: pictures.length - approved},
        {value: "approved", label: "Đã duyệt", count: approved},
      ];
    },
    filteredSelectedKids() {
      const normalize = value => String(value || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toLowerCase();
      const query = normalize(this.selectedStudentSearch).trim();
      const kids = this.updateAlbumRequest.kids || [];
      return query
          ? kids.filter(kid => normalize(kid.kidsName).includes(query)
              || normalize(kid.className).includes(query))
          : kids;
    },
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    listClass() {
      if (this.getAppTypeUserLogin === "plus") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.classList = this.classListCommon;
      } else if (this.getAppTypeUserLogin === "teacher") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.classList = this.classInTeacher;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.classList.push({id: 0, className: "Trường"});
      return this.classList;
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    selectedPictureLoading() {
      const picture = (this.alistPictureList || [])[this.indexSrc];
      return Boolean(picture && picture.imageLoading);
    },
    // eslint-disable-next-line vue/return-in-computed-property
    listSelectObject() {
      if (this.getAppTypeUserLogin === "plus") {
        return [
          { id: 1, value: "school", label: "Trường" },
          { id: 2, value: "student", label: "Lớp" },
        ];
      } else if (this.getAppTypeUserLogin === "teacher") {
        return [
          { id: 2, value: "student", label: "Lớp" },
        ];
      }
    },
  },

  methods: {
    checkPermission,
    handleChangeObject(){
      if (this.updateAlbumRequest.selectObject === "school") {
        this.updateAlbumRequest.listIdKidApply = [];
        this.updateAlbumRequest.classes = [];
        this.updateAlbumRequest.classIds = [];
        this.updateAlbumRequest.idClass = 0;
        this.updateAlbumRequest.kids = [];
      }
    },
    async fetchKidsInSchool() {
      await SurveyForm.getAllKidsSchool()
          .then((res) => {
            this.kidsInSchool = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    async runSequentially() {
      try {
        await this.getSyConfigPicture();
      } catch (error) {
        // Upload configuration must not prevent viewing the album's existing pictures.
        console.error('Album picture configuration error:', error);
      }
      await this.fetchKidsInSchool();
      await this.getAlumDetail();
    },
    clickSelectStudent(){
      this.isAddStudentUpdateAlbumDialog = true;
    },
    closeAddStudentUpdateAlbumDialog(){
      this.isAddStudentUpdateAlbumDialog = false;
    },
    async getSyConfigPicture() {
      await AlbumService.getSyConfigPicture().then((response) => {
        this.qualityPicture = response.data.data.qualityPicture;
        this.widthPicture = response.data.data.widthPicture;
      });
    },
    handleConfirmKidsApply(value) {
      const classes = Array.isArray(value.classesApply) ? value.classesApply : [];
      this.updateAlbumRequest.classes = classes;
      this.updateAlbumRequest.classIds = classes;
      this.updateAlbumRequest.idClass = classes[0] || 0;
      this.updateAlbumRequest.kids = value.kidsApply;
      this.updateAlbumRequest.listIdKidApply = [];
      for (let i = 0; i < this.updateAlbumRequest.kids.length; i++) {
        this.updateAlbumRequest.listIdKidApply.push(this.updateAlbumRequest.kids[i].idKid);
      }
      this.closeAddStudentUpdateAlbumDialog();
    },
    handleChangePicture(file, fileList) {
      this.fileList = fileList;
      if (!file || !file.raw) {
        return false;
      }
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
        return false;
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
        return false;
      }

      this.compressingCount += 1;
      const compressPromise = this.compressImage(file.raw, file.name, file.uid)
          .then((compressedFile) => {
            const existedIndex = this.listUpdate.findIndex(item => item.uid === compressedFile.uid);
            if (existedIndex >= 0) {
              this.listUpdate.splice(existedIndex, 1, compressedFile);
            } else {
              this.listUpdate.push(compressedFile);
            }
          })
          .catch((error) => {
            console.error("Compression error:", error);
            this.$message.error(`Nén ảnh thất bại: ${file.name}`);
          })
          .finally(() => {
            this.compressingCount = Math.max(0, this.compressingCount - 1);
          });

      this.compressPromises.push(compressPromise);
      compressPromise.finally(() => {
        this.compressPromises = this.compressPromises.filter(p => p !== compressPromise);
      });
      return true;
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);
        image.onload = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(image);
        };
        image.onerror = (error) => {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        };
        image.src = objectUrl;
      });
    },
    async compressImage(file, filename, uid) {
      if (!file || file.size <= 300 * 1024) {
        if (file) {
          file.uid = uid;
        }
        return file;
      }

      const image = await this.loadImage(file);
      const originalWidth = image.naturalWidth || image.width;
      const originalHeight = image.naturalHeight || image.height;

      if (!originalWidth || !originalHeight) {
        file.uid = uid;
        return file;
      }

      const targetWidth = Math.min(this.widthPicture || 1280, originalWidth);
      const targetHeight = Math.round((originalHeight * targetWidth) / originalWidth);

      const sourceCanvas = document.createElement("canvas");
      sourceCanvas.width = originalWidth;
      sourceCanvas.height = originalHeight;
      const sourceCtx = sourceCanvas.getContext("2d");
      sourceCtx.drawImage(image, 0, 0, originalWidth, originalHeight);

      const targetCanvas = document.createElement("canvas");
      targetCanvas.width = targetWidth;
      targetCanvas.height = targetHeight;

      const resizedCanvas = await this.picaResizer.resize(sourceCanvas, targetCanvas, {
        unsharpAmount: 80,
        unsharpRadius: 0.6,
        unsharpThreshold: 2,
      });

      const blob = await this.picaResizer.toBlob(
          resizedCanvas,
          "image/jpeg",
          (this.qualityPicture || 80) / 100
      );

      const compressedFile = new File([blob], filename || "image.jpg", {
        type: "image/jpeg",
        lastModified: Date.now(),
      });
      compressedFile.uid = uid;
      return compressedFile;
    },
    tableHeaderColor() {
      return "background-color: var(--primary);color: #fff;font-weight: bold";
    },
    tableRowStyle({row}) {
      row.id;
    },
    submitUpload(fromData) {
      this.$refs[fromData].validate(async (valid) => {
        if (!valid) return;
        this.loadingButton = true;
        this.showProgress = true;
        this.showUpdateProgress = true;
        this.percentage = 5;
        this.updateProgressTitle = "Đang cập nhật album";
        this.updateProgressMessage = "Đang chuẩn bị dữ liệu cập nhật...";
        try {
          if (this.compressPromises.length > 0) {
            this.updateProgressTitle = "Đang chuẩn bị ảnh mới";
            this.updateProgressMessage = "Đang chờ nén ảnh hoàn tất trước khi lưu...";
            await Promise.allSettled(this.compressPromises);
          }
          if (this.fileList.length > 0 && this.listUpdate.length === 0) {
            this.$message.warning("Chưa có ảnh hợp lệ sau khi nén. Vui lòng thử lại.");
            return;
          }

          const albumIdx = this.updateAlbumRequest.albumIdx || this.$route.params.id;
          const pictures = this.fileList.map((file, index) => this.buildPictureMetadata(
              file,
              index,
              (this.updateAlbumRequest.alistPictureList || []).some((picture) =>
                  Boolean(picture.representative || picture.isRepresentative || picture.isAvatar)),
          ));
          const payload = this.buildAlbumUpdatePayload(pictures);

          this.updateAlbumRequest.fileList = this.fileList;
          this.updateProgressTitle = "Đang lưu thông tin album";
          this.updateProgressMessage = this.fileList.length > 0
              ? "Đang lưu thông tin album và metadata ảnh mới..."
              : "Đang lưu thông tin album...";
          const response = await AlbumService.updateAlbumV2(albumIdx, payload);
          const uploadPlan = this.normalizeAlbumUpdateResponse(response, albumIdx, pictures);
          this.percentage = 10;

          this.updateProgressTitle = "Đang tải ảnh lên MinIO";
          this.updateProgressMessage = this.fileList.length > 0
              ? `Đang chuẩn bị ${this.fileList.length} ảnh mới...`
              : "Không có ảnh mới cần tải lên.";
          const usedFallback = await this.uploadAlbumPicturesV2Update(
              uploadPlan.albumIdx,
              pictures,
              this.fileList,
              uploadPlan.pictures,
          );
          this.percentage = 100;
          this.updateProgressTitle = "Hoàn tất cập nhật album";
          this.updateProgressMessage = usedFallback
              ? "MinIO gặp lỗi, ảnh mới đã được lưu bằng máy chủ dự phòng."
              : "Đã hoàn tất cập nhật album và lưu ảnh mới.";
          NotifyMessage.leftCornerNotificationSuccess(
              usedFallback
                  ? "Cập nhật Album thành công, ảnh mới được lưu trên máy chủ."
                  : "Cập nhật Album thành công!",
          );
          await this.getAlumDetail();
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError(
              error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : "Cập nhật thất bại",
          );
          await this.getAlumDetail();
        } finally {
          clearInterval(this.interval);
          this.showProgress = false;
          this.showUpdateProgress = false;
          this.percentage = 0;
          this.loadingButton = false;
          this.fileList = [];
          this.listUpdate = [];
          if (this.$refs.upload) this.$refs.upload.clearFiles();
        }
      });
    },

    buildAlbumUpdatePayload(pictures) {
      const isSchoolAlbum = this.updateAlbumRequest.selectObject === "school";
      const selectedClassIds = isSchoolAlbum
          ? []
          : Array.from(new Set((this.updateAlbumRequest.classIds || this.updateAlbumRequest.classes || [])
              .filter((classId) => classId != null && classId !== "" && classId !== 0 && classId !== "0")));
      const selectedKidIds = isSchoolAlbum
          ? []
          : Array.from(new Set((this.updateAlbumRequest.listIdKidApply || [])
              .filter((kidId) => kidId != null && kidId !== "")));

      return {
        albumName: this.updateAlbumRequest.albumName,
        albumDescription: this.updateAlbumRequest.albumDescription,
        selectObject: this.updateAlbumRequest.selectObject,
        idClass: isSchoolAlbum ? 0 : (selectedClassIds[0] || 0),
        classIds: selectedClassIds,
        listIdKidApply: selectedKidIds,
        pictures,
      };
    },

    buildPictureMetadata(file, index, hasExistingRepresentative) {
      const raw = file.raw || file;
      const token = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : `${Date.now()}_${file.uid || index}_${Math.random().toString(36).slice(2)}`;
      return {
        pictureId: token,
        fileName: raw.name || `${token}.jpg`,
        representative: !hasExistingRepresentative && index === 0,
      };
    },

    normalizeAlbumUpdateResponse(response, fallbackAlbumIdx, requestedPictures) {
      const responseData = response && response.data;
      const payload = responseData && responseData.data !== undefined
          ? responseData.data
          : responseData;
      const body = payload && typeof payload === "object" && !Array.isArray(payload)
          ? payload
          : {};
      const responsePictures = Array.isArray(payload)
          ? payload
          : body.pictures || body.newPictures || body.pictureUploads || body.uploads ||
            body.uploadMetadata || body.newPictureUploadMetadata || [];
      const picturesById = new Map(
          (Array.isArray(responsePictures) ? responsePictures : [])
              .filter((picture) => picture && picture.pictureId)
              .map((picture) => [String(picture.pictureId), picture]),
      );
      const pictures = requestedPictures.map((requested, index) => ({
        ...requested,
        ...((picturesById.get(String(requested.pictureId)) || responsePictures[index]) || {}),
        pictureId: requested.pictureId,
      }));
      const album = body.album || body.detail || {};
      const albumIdx = body.albumIdx || body.idx || body.id || album.albumIdx || album.idx ||
          fallbackAlbumIdx;

      if (requestedPictures.length > 0 && (!Array.isArray(responsePictures) || responsePictures.length === 0)) {
        throw new Error("API cập nhật Album không trả metadata ảnh mới");
      }
      return {albumIdx: String(albumIdx), pictures};
    },

    async uploadAlbumPicturesV2Update(albumIdx, pictures, fileList, uploadMetadata) {
      if (!fileList || fileList.length === 0) return false;
      const uploadedObjectKeys = [];
      const originals = fileList.map((file) => file.raw || file);
      try {
        for (let index = 0; index < fileList.length; index++) {
          const picture = pictures[index];
          const metadata = uploadMetadata[index] || picture;
          const raw = originals[index];
          this.updateProgressTitle = "Đang tải ảnh lên MinIO";
          this.updateProgressMessage = `Đang nén và tải ảnh ${index + 1}/${fileList.length} ...`;
          this.percentage = Math.max(10, Math.round(10 + (index / fileList.length) * 80));
          const compressed = await this.compressImage(raw, raw.name, picture.pictureId);
          const thumbnail = await this.createThumbnail(compressed, picture.pictureId);
          await this.uploadObjectToMinio(
              picture,
              compressed,
              false,
              uploadedObjectKeys,
              metadata,
          );
          await this.uploadObjectToMinio(
              picture,
              thumbnail,
              true,
              uploadedObjectKeys,
              metadata,
          );
          this.percentage = Math.max(10, Math.round(10 + ((index + 1) / fileList.length) * 85));
        }
        return false;
      } catch (uploadError) {
        console.error("Album V2 MinIO upload error:", uploadError);
        this.updateProgressTitle = "Đang chuyển sang máy chủ dự phòng";
        this.updateProgressMessage = "Upload MinIO gặp lỗi, đang dọn dữ liệu đã tải...";
        this.percentage = 90;
        try {
          if (uploadedObjectKeys.length > 0) {
            await AlbumService.cleanupMinioObjectsV2(uploadedObjectKeys);
          }
        } catch (cleanupError) {
          console.error("Album V2 MinIO cleanup error:", cleanupError);
        }

        // This endpoint updates only the new picture IDs. It must not use the
        // create rollback path because the album already existed before PUT.
        this.updateProgressMessage = "Đang tải ảnh mới lên máy chủ dự phòng...";
        await AlbumService.fallbackAlbumPicturesV2Update(
            albumIdx,
            pictures.map((picture) => picture.pictureId),
            originals,
        );
        this.percentage = 98;
        this.updateProgressMessage = "Đã lưu ảnh mới bằng máy chủ dự phòng.";
        return true;
      }
    },

    async uploadObjectToMinio(picture, file, thumbnail, uploadedObjectKeys, metadata = {}) {
      const expectedObjectKey = thumbnail
          ? metadata.objectKeyThumbnail || metadata.thumbnailObjectKey
          : metadata.objectKey || metadata.objectKeyOriginal;
      const directUploadUrl = thumbnail
          ? metadata.thumbnailUploadUrl || metadata.uploadUrlThumbnail
          : metadata.uploadUrl || metadata.originalUploadUrl;
      let uploadInfo = {
        uploadUrl: directUploadUrl,
        objectKey: expectedObjectKey,
      };
      if (!uploadInfo.uploadUrl) {
        const response = await AlbumService.getMinioUploadUrlV2(
            picture.pictureId,
            picture.fileName,
            thumbnail,
        );
        uploadInfo = response.data.data;
      }
      const objectKey = uploadInfo.objectKey || expectedObjectKey;
      if (expectedObjectKey && uploadInfo.objectKey && expectedObjectKey !== uploadInfo.objectKey) {
        throw new Error(`API cấp sai object key cho ảnh ${picture.pictureId}`);
      }
      if (!objectKey || !uploadInfo.uploadUrl) {
        throw new Error(`API không trả thông tin upload cho ảnh ${picture.pictureId}`);
      }
      // Record before PUT so a network error after MinIO receives bytes is
      // still included in cleanup.
      uploadedObjectKeys.push(objectKey);
      const result = await fetch(uploadInfo.uploadUrl, {
        method: "PUT",
        headers: {"Content-Type": file.type || "image/jpeg"},
        body: file,
      });
      if (!result.ok) throw new Error(`Upload MinIO thất bại: ${objectKey}`);
    },

    async createThumbnail(compressedFile, pictureId) {
      const image = await this.loadImage(compressedFile);
      const maxWidth = 256;
      const ratio = Math.min(1, maxWidth / image.width);
      const targetWidth = Math.max(1, Math.round(image.width * ratio));
      const targetHeight = Math.max(1, Math.round(image.height * ratio));
      const sourceCanvas = document.createElement("canvas");
      sourceCanvas.width = image.width;
      sourceCanvas.height = image.height;
      sourceCanvas.getContext("2d").drawImage(image, 0, 0);
      const targetCanvas = document.createElement("canvas");
      targetCanvas.width = targetWidth;
      targetCanvas.height = targetHeight;
      await this.picaResizer.resize(sourceCanvas, targetCanvas);
      const outputType = compressedFile.type || "image/jpeg";
      const blob = await this.picaResizer.toBlob(targetCanvas, outputType, 0.8);
      const extension = outputType === "image/png" ? "png" : "jpg";
      return new File([blob], `thumbnail_${pictureId}.${extension}`, {type: outputType});
    },

    handleRemove(file) {
      if (this.$refs.upload && Array.isArray(this.$refs.upload.uploadFiles)) {
        const upIndex = this.$refs.upload.uploadFiles.findIndex(item => item.uid === file.uid);
        if (upIndex >= 0) {
          this.$refs.upload.uploadFiles.splice(upIndex, 1);
        }
      }
      const indexAlbumRequest = this.listUpdate.findIndex(item => item.uid === file.uid);
      if (indexAlbumRequest >= 0) {
        this.listUpdate.splice(indexAlbumRequest, 1);
      }
      const indexFile = this.fileList.findIndex(item => item.uid === file.uid);
      if (indexFile >= 0) {
        this.fileList.splice(indexFile, 1);
      }
      if (this._createdPreviews && this._createdPreviews[file.uid]) {
        try { URL.revokeObjectURL(this._createdPreviews[file.uid]); } catch (e) { /* ignore */ }
        delete this._createdPreviews[file.uid];
      }
    },

    clearAllSelected() {
      if (this._createdPreviews) {
        this.fileList.forEach(f => {
          const url = this._createdPreviews[f.uid];
          if (url) {
            try { URL.revokeObjectURL(url); } catch (e) { /* ignore */ }
            delete this._createdPreviews[f.uid];
          }
        });
      }
      this.fileList = [];
      this.listUpdate = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },

    getPreview(file) {
      if (!file) return '';
      const url = file.url || file.thumbUrl;
      if (url) return url;
      if (file.raw && file.raw instanceof File) {
        if (!this._createdPreviews) this._createdPreviews = {};
        if (!this._createdPreviews[file.uid]) {
          this._createdPreviews[file.uid] = URL.createObjectURL(file.raw);
        }
        return this._createdPreviews[file.uid];
      }
      return '';
    },

    formatSize(bytes) {
      if (!bytes) return '';
      const kb = 1024;
      if (bytes < kb) return bytes + ' B';
      const mb = kb * 1024;
      if (bytes < mb) return (bytes / kb).toFixed(1) + ' KB';
      return (bytes / mb).toFixed(1) + ' MB';
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url || this.getPreview(file);
      this.dialogVisible = true;
    },
    handleShowDetailPicture(index, listPicture, event) {
      this._viewerReturnFocus = event && event.currentTarget;
      this.viewerFullscreen = false;
      this.showViewerPicture(index);
      this.dialogVisiblePic = true;
    },
    showViewerPicture(index) {
      const pictures = this.alistPictureList || [];
      if (!pictures.length) return;
      this.indexSrc = Math.max(0, Math.min(pictures.length - 1, index));
      this.viewerZoom = 1;
      this.handleLinkUrl(pictures[this.indexSrc]);
      this.$nextTick(() => {
        const viewer = this.$refs.pictureViewer;
        const active = viewer && viewer.$el.querySelector('.album-viewer-thumbnails .is-active');
        if (active) active.scrollIntoView({block: "nearest", inline: "nearest"});
      });
    },
    changeViewerZoom(delta) {
      this.viewerZoom = Math.max(1, Math.min(3, this.viewerZoom + delta));
    },
    onViewerOpened() {
      const viewer = this.$refs.pictureViewer;
      const close = viewer && viewer.$el.querySelector('.el-dialog__headerbtn');
      if (close) close.focus();
    },
    onViewerClosed() {
      this.viewerZoom = 1;
      this.viewerFullscreen = false;
      const target = this._viewerReturnFocus;
      if (target && document.documentElement.contains(target)) target.focus();
      this._viewerReturnFocus = null;
    },
    handleViewerKeydown(event) {
      if (!this.dialogVisiblePic || this.showDownloadProgress || this.settingAvatar) return;
      if (event.key === "Tab") {
        const viewer = this.$refs.pictureViewer;
        if (!viewer) return;
        const buttons = Array.from(viewer.$el.querySelectorAll('button:not([disabled]), [tabindex="0"]'))
            .filter(element => element.getClientRects().length);
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (first && event.shiftKey && (event.target === first || !buttons.includes(event.target))) {
          event.preventDefault(); last.focus();
        } else if (last && !event.shiftKey && (event.target === last || !buttons.includes(event.target))) {
          event.preventDefault(); first.focus();
        }
        return;
      }
      if (event.altKey || event.ctrlKey || event.metaKey || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName) || event.target.isContentEditable) return;
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        if (event.key === "ArrowLeft") this.backPage();
        else this.nextPage();
      }
    },
    nextPage() { this.showViewerPicture(this.indexSrc + 1); },
    backPage() { this.showViewerPicture(this.indexSrc - 1); },
    handlePreviewImageError(event) {
      const picture = (this.alistPictureList || [])[this.indexSrc];
      // An error from the previous image must not replace the current selection.
      if (!picture || event.target.getAttribute("src") !== this.selectedImg) return;
      const previewUrl = picture.urlPictureShow;
      if (previewUrl && previewUrl !== this.selectedImg) {
        this.selectedImg = previewUrl;
        return;
      }
      this.handleAlbumImageError(picture);
    },
    handleLinkUrl(listPicture) {
      this.selectedImg = listPicture.urlPictureShow ? listPicture.urlPicture : "";
      this.selectedPictureIdx = String(
          listPicture.pictureIdx ?? listPicture.idx ?? listPicture.id ?? "",
      );
    },
    createEmployeeDialog() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
    },
    normalizeAlbumDetail(payload, searchId) {
      const album = payload && typeof payload === "object" ? (payload.album || payload.detail || payload) : {};
      const albumIdx = album.idx ?? album.albumIdx ?? album.id;
      const persistedType = String(album.type || album.albumType || "").toUpperCase();
      const responseSelectObject = String(album.selectObject || "").toUpperCase();
      const selectObject = responseSelectObject === "CLASS" || responseSelectObject === "STUDENT"
          ? "student"
          : responseSelectObject === "SCHOOL"
            ? "school"
            : (persistedType === "CLASS" ? "student" : "school");
      const rawClassIds = album.classIds || album.classes || (album.idClass ? [album.idClass] : []);
      const classIds = Array.from(new Set((Array.isArray(rawClassIds) ? rawClassIds : [rawClassIds]).filter((classId) =>
          classId != null && classId !== "" && classId !== 0 && classId !== "0")));
      const linkedKidSource = [album.listIdKidApply, album.kidIds, album.kidsIds,
        album.studentIds, album.kids, album.students, album.listKids]
          .find((value) => Array.isArray(value) ? value.length > 0 : value != null);
      const rawLinkedKids = linkedKidSource || [];
      const listIdKidApply = (Array.isArray(rawLinkedKids) ? rawLinkedKids : [rawLinkedKids])
          .map((kid) => typeof kid === "object"
              ? (kid.idKid ?? kid.kidId ?? kid.id ?? kid.idKids)
              : kid)
          .filter((kidId) => kidId != null && kidId !== "")
          .map((kidId) => String(kidId));
      const rawPictures = album.pictures || album.pictureList || album.alistPictureList ||
          album.albumPictures || album.images || [];
      const pictures = (Array.isArray(rawPictures) ? rawPictures : []).map((picture, index) => {
        const storageStatus = picture.storageStatus || picture.status_S3_SV || picture.status || "";
        const objectKey = picture.objectKey || picture.objectKeyOriginal || "";
        const urlMinio = picture.urlMinio || "";
        const imageNeedsPresign = AlbumImageUrlService.needsPresignedUrl({
          storageStatus,
          objectKey,
          urlMinio,
        });
        const url = picture.urlPictureShow || picture.urlShow || picture.url || picture.thumbnailUrl ||
            picture.compressedUrl || picture.originalUrl || "";
        return {
          ...picture,
          id: picture.id ?? picture.idx ?? picture.pictureIdx ?? index,
          pictureIdx: String(picture.idx ?? picture.pictureIdx ?? picture.id ?? index),
          urlPicture: imageNeedsPresign ? "" : (picture.urlPicture || picture.originalUrl || url),
          urlPictureShow: "",
          imageSourceUrl: imageNeedsPresign ? "" : url,
          objectKey,
          urlMinio,
          storageStatus,
          imageLoading: imageNeedsPresign || Boolean(url),
          imageError: false,
          imageRefreshAttempted: false,
          imageSearchId: searchId,
          checkDelete: false,
          isApproved: picture.isApproved ?? picture.approved ?? picture.approvalStatus === "APPROVED",
        };
      });
      return {
        ...album,
        id: album.id ?? album.idx ?? album.albumIdx,
        albumIdx: albumIdx == null ? "" : String(albumIdx),
        albumName: album.albumName || album.name || "Album không tên",
        albumDescription: album.albumDescription || album.description || "",
        alistPictureList: pictures,
        pictureNumber: album.count ?? album.pictureNumber ?? album.pictureCount ?? pictures.length,
        pictureApprovedNumber: album.pictureApprovedNumber ??
            pictures.filter((picture) => picture.isApproved).length,
        albumApproved: Boolean(album.approved),
        listIdKidApply: Array.from(new Set(listIdKidApply)),
        // Keep the rendered student list reactive after replacing the
        // request object with the API response.
        kids: [],
        selectObject,
        classIds,
        classes: classIds,
        idClass: album.idClass || classIds[0] || 0,
      };
    },
    getAlumDetail() {
      if (this._albumImageLoader.destroyed) return Promise.resolve();
      const searchId = this.cancelPendingAlbumImages();
      this.detailLoading = true;
      this.detailError = false;
      return AlbumService.getAlbumDetailV2(this.$route.params.id)
          .then((res) => {
            if (!this.isAlbumImageSearchCurrent(searchId)) return;
            const payload = res.data && res.data.data != null ? res.data.data : res.data;
            this.updateAlbumRequest = this.normalizeAlbumDetail(payload, searchId);
            this.classesApply = this.updateAlbumRequest.classIds || [];
            this.updateAlbumRequest.classes = this.classesApply;

            this.alistPictureList = this.updateAlbumRequest.alistPictureList;
            this.resetPictureSelection();
            this.alistPictureList.forEach((picture) => {
              if (AlbumImageUrlService.needsPresignedUrl(picture) || picture.imageSourceUrl) {
                this.queueAlbumImage(picture);
              }
            });
            this.idKidApply = this.updateAlbumRequest.listIdKidApply || [];
            const linkedKidIds = new Set(this.idKidApply.map((kidId) => String(kidId)));
            this.$set(this.updateAlbumRequest, "kids", this.kidsInSchool.filter((kid) =>
                linkedKidIds.has(String(kid.idKid))));
          })
          .catch((e) => {
            if (!this.isAlbumImageSearchCurrent(searchId)) return;
            this.detailError = true;
            console.log(e);
          }).finally(() => {
            if (this.isAlbumImageSearchCurrent(searchId)) this.detailLoading = false;
          });
    },
    retryAlbumImage(picture) {
      if (picture.imageLoading) return;
      this.$set(picture, "imageRefreshAttempted", false);
      this.queueAlbumImage(picture, true);
    },
    isAlbumImageSearchCurrent(searchId) {
      const loader = this._albumImageLoader;
      return !loader.destroyed && loader.searchId === searchId;
    },
    cancelPendingAlbumImages() {
      const loader = this._albumImageLoader;
      loader.searchId += 1;
      loader.queue.length = 0;
      return loader.searchId;
    },
    queueAlbumImage(picture, force = false) {
      if (!this.isAlbumImageSearchCurrent(picture.imageSearchId)) return;
      const cachedUrl = force ? "" : AlbumImageUrlService.getCachedUrl(picture);
      if (cachedUrl) {
        this.resolveAlbumImage(picture, false, cachedUrl);
        return;
      }
      this._albumImageLoader.queue.push({picture, force});
      this.processAlbumImageQueue();
    },
    async processAlbumImageQueue() {
      const loader = this._albumImageLoader;
      if (loader.running) return;
      loader.running = true;
      try {
        while (!loader.destroyed && loader.queue.length > 0) {
          const task = loader.queue.shift();
          if (!this.isAlbumImageSearchCurrent(task.picture.imageSearchId)) continue;
          const cachedUrl = task.force ? "" : AlbumImageUrlService.getCachedUrl(task.picture);
          await this.resolveAlbumImage(task.picture, task.force, cachedUrl);
          // Publish the URL before resolving the next image; no fixed delay.
          await this.$nextTick();
        }
      } finally {
        loader.running = false;
      }
    },
    async resolveAlbumImage(picture, force = false, cachedUrl = "") {
      const searchId = picture.imageSearchId;
      if (!this.isAlbumImageSearchCurrent(searchId)) return;
      this.$set(picture, "imageLoading", true);
      try {
        if (force) AlbumImageUrlService.invalidate(picture);
        const imageNeedsPresign = AlbumImageUrlService.needsPresignedUrl(picture);
        const url = cachedUrl || (imageNeedsPresign
            ? await AlbumImageUrlService.resolve(picture, {force})
            : picture.imageSourceUrl);
        if (!this.isAlbumImageSearchCurrent(searchId)) return;
        if (imageNeedsPresign) this.$set(picture, "urlPicture", url || "");
        this.$set(picture, "urlPictureShow", url || "");
        this.$set(picture, "imageError", !url);
        if (this.dialogVisiblePic && this.selectedPictureIdx === this.getPictureIdx(picture)) {
          this.selectedImg = picture.urlPicture || "";
        }
      } catch (error) {
        if (!this.isAlbumImageSearchCurrent(searchId)) return;
        this.$set(picture, "imageError", true);
        console.error("Album detail image URL error:", error);
      } finally {
        if (this.isAlbumImageSearchCurrent(searchId)) {
          this.$set(picture, "imageLoading", false);
        }
      }
    },
    handleAlbumImageError(picture) {
      if (!this.isAlbumImageSearchCurrent(picture.imageSearchId)) return;
      if (this.dialogVisiblePic && this.selectedPictureIdx === this.getPictureIdx(picture)) {
        this.selectedImg = "";
      }
      if (!AlbumImageUrlService.needsPresignedUrl(picture) || picture.imageRefreshAttempted) {
        this.$set(picture, "imageError", true);
        return;
      }
      this.$set(picture, "imageRefreshAttempted", true);
      this.$set(picture, "imageLoading", true);
      this.$set(picture, "imageError", true);
      this.queueAlbumImage(picture, true);
    },

    getPictureIdx(picture) {
      return picture && String(
          picture.pictureIdx ?? picture.idx ?? picture.id ?? "",
      );
    },
    handlePictureSelectionChange(picture) {
      const pictureIdx = this.getPictureIdx(picture);
      if (!pictureIdx) return;
      this.$set(picture, "checkDelete", Boolean(picture.checkDelete));
      this.syncPictureSelectionState();
    },
    handleCheckAllPictures(checked) {
      this.visiblePictures.forEach((picture) => {
        this.$set(picture, "checkDelete", Boolean(checked));
      });
      this.syncPictureSelectionState();
    },
    syncPictureSelectionState() {
      const pictures = this.alistPictureList || [];
      const selected = pictures
          .filter((picture) => picture.checkDelete)
          .map((picture) => this.getPictureIdx(picture))
          .filter(Boolean);
      this.selectedPictureIdxs = Array.from(new Set(selected));
      const visible = this.visiblePictures;
      const visibleSelected = visible.filter(picture => picture.checkDelete).length;
      this.checkAllPictures = visible.length > 0 && visibleSelected === visible.length;
      this.pictureSelectionIndeterminate = visibleSelected > 0 && visibleSelected < visible.length;
    },
    resetPictureSelection() {
      (this.alistPictureList || []).forEach((picture) => {
        this.$set(picture, "checkDelete", false);
      });
      this.selectedPictureIdxs = [];
      this.checkAllPictures = false;
      this.pictureSelectionIndeterminate = false;
    },
    deleteSelectedPictures() {
      const pictureIdxs = [...this.selectedPictureIdxs];
      if (pictureIdxs.length === 0) return;
      this.$confirm(
          `Bạn có chắc chắn muốn xóa ${pictureIdxs.length} ảnh đã chọn?`,
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
            type: "warning",
          },
      ).then(() => this.deletePictures(pictureIdxs)).catch(() => {});
    },
    deleteSinglePicture(picture) {
      const pictureIdx = this.getPictureIdx(picture);
      if (!pictureIdx) {
        NotifyMessage.leftCornerNotificationError("Không xác định được ảnh cần xóa");
        return;
      }
      this.$confirm(
          "Bạn có chắc chắn muốn xóa ảnh này?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
            type: "warning",
          },
      ).then(() => this.deletePictures([pictureIdx])).catch(() => {});
    },
    async deletePictures(pictureIdxs) {
      const normalizedPictureIdxs = Array.from(new Set(
          (pictureIdxs || []).map((pictureIdx) => String(pictureIdx)).filter(Boolean),
      ));
      const albumIdx = this.updateAlbumRequest.albumIdx || this.$route.params.id;
      if (!albumIdx || normalizedPictureIdxs.length === 0) return;

      this.deletePictureLoading = true;
      this.deletingPictureIdxs = normalizedPictureIdxs;
      try {
        await AlbumService.deletePicturesV2(albumIdx, normalizedPictureIdxs);
        if (normalizedPictureIdxs.includes(String(this.selectedPictureIdx))) {
          this.dialogVisiblePic = false;
          this.selectedPictureIdx = "";
        }
        await this.getAlumDetail();
        this.$message({
          message: normalizedPictureIdxs.length === 1
              ? "Xóa ảnh thành công"
              : `Xóa ${normalizedPictureIdxs.length} ảnh thành công`,
          type: "success",
        });
      } catch (error) {
        console.error("Album picture delete error:", error);
        this.$message({
          message: normalizedPictureIdxs.length === 1
              ? "Xóa ảnh thất bại"
              : "Xóa ảnh đã chọn thất bại",
          type: "error",
        });
      } finally {
        this.deletePictureLoading = false;
        this.deletingPictureIdxs = [];
      }
    },

    updateApprovePicture(pictureIdx, approved) {
      if (this.pictureApprovalLoading) return;
      this.$confirm(
          approved ? "Bạn có chắc chắn muốn duyệt ảnh đã chọn?" : "Bạn có chắc chắn muốn hủy duyệt ảnh đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          },
      ).then(async () => {
        try {
          await AlbumService.updatePictureApprovalV2(
              this.updateAlbumRequest.albumIdx,
              pictureIdx,
              approved,
          );
          this.$message({
            message: approved ? "Duyệt ảnh thành công" : "Hủy duyệt ảnh thành công",
            type: "success",
          });
          await this.getAlumDetail();
        } catch (err) {
          console.log(err);
          this.$message({
            message: approved ? "Duyệt ảnh thất bại" : "Hủy duyệt ảnh thất bại",
            type: "error",
          });
        }
      });
    },
    async updateAllPictureApproval(approved) {
      if (this.pictureApprovalLoading || this.deletePictureLoading) return;
      const pictureIdxs = [...this.selectedPictureIdxs];
      if (pictureIdxs.length === 0) {
        this.$message({message: "Vui lòng chọn ảnh cần duyệt hoặc hủy duyệt", type: "warning"});
        return;
      }
      const albumIdx = this.updateAlbumRequest.albumIdx;
      this.pictureApprovalLoading = true;
      this.pictureApprovalTarget = approved;
      try {
        try {
          await this.$confirm(
              `Bạn có chắc chắn muốn ${approved ? "duyệt" : "hủy duyệt"} ${pictureIdxs.length} ảnh đã chọn?`,
              "Thông báo!",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "Có",
                closeOnClickModal: false,
                cancelButtonText: "Không",
              },
          );
        } catch {
          return;
        }
        let failedCount = 0;
        for (const pictureIdx of pictureIdxs) {
          try {
            await AlbumService.updatePictureApprovalV2(albumIdx, pictureIdx, approved);
          } catch (error) {
            failedCount += 1;
            console.error("Album picture approval error:", error);
          }
        }
        await this.getAlumDetail();
        this.$message({
          message: failedCount > 0
              ? `Đã cập nhật ${pictureIdxs.length - failedCount}/${pictureIdxs.length} ảnh đã chọn; ${failedCount} ảnh thất bại`
              : `${approved ? "Duyệt" : "Hủy duyệt"} ${pictureIdxs.length} ảnh đã chọn thành công`,
          type: failedCount > 0 ? "error" : "success",
        });
      } finally {
        this.pictureApprovalLoading = false;
      }
    },

    async setUpAvatarAlbum() {
      const albumIdx = this.updateAlbumRequest.albumIdx || this.$route.params.id;
      const pictureIdx = this.selectedPictureIdx;
      if (!albumIdx || !pictureIdx) {
        NotifyMessage.leftCornerNotificationError("Không xác định được ảnh cần đặt làm đại diện");
        return;
      }

      this.settingAvatar = true;
      try {
        await AlbumService.setRepresentativePictureV2(albumIdx, pictureIdx);
        const pictures = this.updateAlbumRequest.alistPictureList || [];
        pictures.forEach((picture) => {
          const currentPictureIdx = String(
              picture.pictureIdx ?? picture.idx ?? picture.id ?? "",
          );
          const isRepresentative = currentPictureIdx === String(pictureIdx);
          this.$set(picture, "representative", isRepresentative);
          this.$set(picture, "isRepresentative", isRepresentative);
        });
        this.alistPictureList = pictures;
        NotifyMessage.leftCornerNotificationSuccess("Đặt ảnh đại diện thành công");
      } catch (error) {
        console.error("Set album representative picture error:", error);
        NotifyMessage.leftCornerNotificationError("Đặt ảnh đại diện thất bại");
      } finally {
        this.settingAvatar = false;
      }
    },

    async downloadCurrentPicture() {
      const albumIdx = this.updateAlbumRequest.albumIdx || this.$route.params.id;
      const picture = (this.alistPictureList || [])[this.indexSrc];
      const pictureIdx = picture && String(
          picture.pictureIdx ?? picture.idx ?? picture.id ?? "",
      );
      if (!albumIdx || !pictureIdx) {
        NotifyMessage.leftCornerNotificationError("Không xác định được ảnh cần tải");
        return;
      }

      this.downloadingPicture = true;
      this.showDownloadProgress = true;
      this.downloadProgressTitle = "Đang chuẩn bị tải ảnh";
      this.downloadProgressMessage = "Đang tạo liên kết tải xuống...";
      try {
        const response = await AlbumService.downloadPictureV2(albumIdx, pictureIdx);
        this.downloadProgressTitle = "Đang bắt đầu tải ảnh";
        this.downloadProgressMessage = "Đã tạo liên kết, trình duyệt đang bắt đầu tải ảnh...";
        const envelope = response.data || {};
        const payload = envelope.data != null ? envelope.data : envelope;
        const downloadUrl = typeof payload === "string"
            ? payload
            : payload.downloadUrl || payload.url;
        if (!downloadUrl) {
          throw new Error("API không trả về URL tải ảnh");
        }
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = (payload && payload.fileName) || `${pictureIdx}.jpg`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.downloadProgressTitle = "Đã bắt đầu tải ảnh";
        this.downloadProgressMessage = "Ảnh đang được tải xuống trên trình duyệt.";
        NotifyMessage.leftCornerNotificationSuccess("Đã bắt đầu tải ảnh. Theo dõi tiến trình trong trình duyệt.");
      } catch (error) {
        console.error("Album picture download error:", error);
        NotifyMessage.leftCornerNotificationError("Tải ảnh thất bại");
      } finally {
        this.showDownloadProgress = false;
        this.downloadProgress = 0;
        this.downloadingPicture = false;
      }
    },

  },
  beforeDestroy() {
    this._albumImageLoader.destroyed = true;
    this.cancelPendingAlbumImages();
  },
};
</script>
